export const RECONNECT_HERO_DONE = 'RECONNECT_HERO_DONE';
//# sourceMappingURL=actionTypes.js.map